<template style="height:100%">
  <div class="Add_factor_problem">
    <el-form label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="papername" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="所属上一级题目">
        <el-select v-model="pquestionID" placeholder="请选择因子名称" @change="getinfo()">
          <el-option v-for="(item,i) in options" :key="i" :label="item.questionName" :value="item.questionID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="题目名称">
        <el-input v-model="questionName"></el-input>
      </el-form-item>

 
      <el-form-item label="计分规则">
        <el-radio-group v-model="scoreType">
          <el-radio label="0">正向计分</el-radio>
          <el-radio label="1">反向计分</el-radio>
        </el-radio-group>
      </el-form-item>




      <el-form-item label="题目公式">
        <el-radio-group v-model="calFormula">
          <el-radio label="-1">常模对照</el-radio>
          <el-radio label="1">公式</el-radio>
          <el-radio label="0">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目答案类型">
        <el-radio-group v-model="questionType">
          <el-radio label="1">单选</el-radio>
          <el-radio label="2">多选</el-radio>
          <el-radio label="3">填空</el-radio>
          <el-radio label="4">单选填空</el-radio>
          <el-radio label="5">多选填空</el-radio>
          <el-radio label="6">简答题</el-radio>
          <el-radio label="7">单选简答题</el-radio>
          <el-radio label="8">多选简答题</el-radio>
          <el-radio label="9">时间填空</el-radio>
          <el-radio label="10">日期填空</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="多选选项控制">
        <el-input v-model="minSelect" placeholder="最少可选项，-1表示可跳过"></el-input>-<el-input v-model="maxSelect" placeholder="最多可选项"></el-input>
      </el-form-item>

      <el-form-item label="题目限时">
        <el-input v-model="timeLimit" placeholder="单位：秒 单位：秒 说明:只能输入数字。"></el-input>
      </el-form-item>

      <el-form-item label="题目排序">
        <el-input v-model="lineNumber" ></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-radio-group v-model="isActive">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="上传视频">

        <el-upload style="background-color: rgba(0, 136, 255, 1);height: 42px;padding: 0px 20px;color: aliceblue;margin-left:60px;width: 60px;" 
        :on-change="videohandleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" 
         accept=".gif, .png, .bmp,.jpg,.mp4">
           上传视频
        </el-upload>

        <p style="margin-left: 260px;color: #606266;">{{url1?url1:''}}</p>
      </el-form-item>

      <el-form-item label="上传音频">

        <el-upload style="background-color: rgba(0, 136, 255, 1);height: 42px;padding: 0px 20px;color: aliceblue;margin-left:60px;width: 60px;" 
        :on-change="videohandleChange2" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" 
         accept=".mp3">
           上传音频
        </el-upload>
        <p style="margin-left: 260px;color: #606266;">{{url2?url2:''}}</p>

      </el-form-item>

      <el-form-item label="描述">
        <el-input v-model="remark" ></el-input>
      </el-form-item>

      <el-form-item label="标签">
        <el-input v-model="tagging" ></el-input>
      </el-form-item>

      <el-button v-if="pds" type="primary" @click="addfun(1)" style="margin-left:250px">确定</el-button>
      <el-button v-else type="primary" @click="addfun(2)" style="margin-left:250px">确定</el-button>
    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" >
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        pds:true,
        papername:'',//量表名称
        paperID:'',//量表id
        pquestionID:'',//所属上一级题目
        questionName:'',//题目代号
        calFormula:'',//题目公式
        questionType:'',//题目答案类型
        minSelect:'',//最少选
        maxSelect:'',//最多选
        timeLimit:'',//题目限时
        lineNumber:'',//题目排序
        isActive:'',//是否启用
        remark:'',//描述
        tagging:'',//标签
        questionImg:'',//文件
        scoreType:'0',//文件

        url1:'',
        url2:'',
        dialogVisible:false,
        options:[],
        options2:[],
        xgquestionID:'',
        questionVoice:'',
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      getinfo(data){//根据因子获取数据
        this.$Http_Post('paperconfig/answercfg/list', {questionID:this.pquestionID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options2 = res.Data
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      addfun(val){
        if(val == 1){
          var from = new FormData();
          from.append('questionImg',  this.questionImg.raw);
          from.append('paperID',      this.paperID);
          from.append('pquestionID',  this.pquestionID?this.pquestionID:'0');
          from.append('questionName', this.questionName);
          from.append('calFormula',   this.calFormula);
          from.append('questionType', this.questionType);
          from.append('minSelect',    this.minSelect);
          from.append('maxSelect',    this.maxSelect);
          from.append('timeLimit',    this.timeLimit);
          from.append('lineNumber',   this.lineNumber);
          from.append('isActive',     this.isActive);
          from.append('remark',       this.remark);
          from.append('tagging',      this.tagging);
          from.append('scoreType',    this.scoreType);
          from.append('questionVoice',    this.questionVoice.raw);
          this.$Http_Post('paperconfig/questioncfg/add', from, {'Content-Type':'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }else{
          var from = new FormData();
          from.append('questionImg',  this.questionImg.raw);
          from.append('paperID',      this.paperID);
          from.append('pquestionID',  this.pquestionID?this.pquestionID:'0');
          from.append('questionName', this.questionName);
          from.append('calFormula',   this.calFormula);
          from.append('questionType', this.questionType);
          from.append('minSelect',    this.minSelect);
          from.append('maxSelect',    this.maxSelect);
          from.append('timeLimit',    this.timeLimit);
          from.append('lineNumber',   this.lineNumber);
          from.append('isActive',     this.isActive);
          from.append('remark',       this.remark);
          from.append('tagging',      this.tagging);
          from.append('scoreType',    this.scoreType);
          from.append('questionID',   this.xgquestionID);
          from.append('questionVoice',    this.questionVoice.raw);
          this.$Http_Post('paperconfig/questioncfg/edit', from, {'Content-Type':'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }
      },
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        this.papername = val.label;
        this.paperID = val.val;
        this.$Http_Post('paperconfig/questioncfg/list', {paperID:val.val,pquestionID:'0'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      videohandleChange(file, fileList) {
        this.questionImg = file;
      },
      videohandleChange2(file, fileList) {
        this.questionVoice = file;
      },
    },
    mounted(){
      if([this.$route.query.paperID][0]){
        this.pds = false
        this.$Http_Post('paperconfig/questioncfg/list', {paperID:[this.$route.query.paperID][0],pquestionID:'0'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options = res.Data;
            this.$Http_Post('paperconfig/questioncfg/getinfo', {questionID:[this.$route.query.questionID][0]}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.papername = res.Data.paperName;//量表名称
                this.questionName = res.Data.questionName;//量表名称
                this.paperID = res.Data.paperID;//量表id
                this.pquestionID = Number(res.Data.pquestionID) == 0 ?'':Number(res.Data.pquestionID); //所属上一级题目
                this.calFormula = res.Data.calFormula.toString();//题目公式
                this.questionType = res.Data.questionType.toString();//题目答案类型
                this.minSelect = res.Data.minSelect;//最少选
                this.maxSelect = res.Data.maxSelect;//最多选
                this.timeLimit = res.Data.timeLimit;//题目限时
                this.lineNumber = res.Data.lineNumber;//题目排序
                this.isActive = res.Data.isActive.toString();//是否启用
                this.remark = res.Data.remark;//描述
                this.tagging = res.Data.tagging;//标签
                this.xgquestionID = res.Data.questionID;//标签
                this.url1 = res.Data.questionImgPath;//标签
                this.url2 = res.Data.questionVoicePath;//标签
              }else{
                this.Global.request_failure(res.Message);
              }
            });
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      }else{
        this.pds = true;
      }
    }
  };
</script>
<style>
.Add_factor_problem {width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_factor_problem .el-input, .el-textarea{width: 500px;}
.Add_factor_problem .el-textarea__inner{height: 80px !important;}
.Add_factor_problem .el-form-item__label{width: 140px !important;}
</style>